"use strict";exports.__esModule=true;exports.default=void 0;var _default=function _default(str1,str2){return String(str1).toLowerCase()===String(str2).toLowerCase()};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/string/equal.js
// module id = MLpj
// module chunks = 5